import { useMemo } from "react";
export const EDITOR_CONFIG = {
  readonly: false,
  placeholder: "",
  defaultActionOnPaste: "insert_as_html",
  defaultLineHeight: 1.5,
  enter: "div",
  // options that we defined in above step.
  buttons: [
    "bold",
    "italic",
    "ul",
    "ol",
    "hr",
    "fullsize",
    "table",
    "link",
    "left",
    "right",
  ],
  statusbar: false,
  sizeLG: 900,
  sizeMD: 700,
  sizeSM: 400,
  toolbarAdaptive: false,
  toolbar: true,
};
